import React from 'react';

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var Logo = function (props) { return (React.createElement("svg", __assign({ width: 32, height: 32 }, props),
    React.createElement("defs", null,
        React.createElement("linearGradient", { x1: "19.732%", y1: "0%", x2: "100%", y2: "0%", id: "a" },
            React.createElement("stop", { stopColor: "var(--color-primary)", offset: "0%" }),
            React.createElement("stop", { stopColor: "var(--color-primary-bright)", offset: "100%" }))),
    React.createElement("circle", { cx: 28, cy: 28, r: 14, transform: "translate(-12 -12)", stroke: "url(#a)", fill: "none", fillRule: "evenodd", strokeWidth: "2" }))); };

export { Logo };
